<script lang="ts">
import {Vue, Component} from 'vue-facing-decorator';
import {useColorStore} from "@/stores";
import {useRouter} from "vue-router";

@Component({})
export default class NavBar extends Vue {
  private colorStore = useColorStore();
  private router = useRouter();

  private toggleTheme() {
    this.colorStore.toggleTheme();
  }

  private navigateToHome() {
    this.router.push({name: 'home'});
  }

  private navigateToAbout() {
    this.router.push({name: 'about'});
  }

  private navigateToCompetence() {
    this.router.push({name: 'competences'});
  }

  private navigateToCV() {
    this.router.push({name: 'cv'});
  }
}
</script>

<template>
  <header class="header">
    <div class="top">
      <a @click="navigateToHome" class="mdi mdi-home" v-tooltip="'Accueil'"></a>
      <a @click="navigateToAbout" class="mdi mdi-information" v-tooltip="'À Propos de moi'"></a>
      <a @click="navigateToCompetence" class="mdi mdi-account-badge-outline" v-tooltip="'Compétences'"></a>
      </div>
    <div class="bottom">
      <a @click="navigateToCV" class="mdi mdi-file-document-outline"
         v-tooltip="'Mon CV'"></a>
      <a href="mailto:timothe.natte@etu.umontpellier.fr" class="mdi mdi-gmail" v-tooltip="'Mail'"></a>
    </div>
  </header>
</template>

<style scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 80px;
  height: 100vh;
  background: linear-gradient(180deg, var(--navbar-background-color) 0%, #0a0e27 100%);
  color: var(--text-color);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
  z-index: 1000;
  box-shadow: 4px 0 20px rgba(0, 0, 0, 0.5);
  border-right: 1px solid var(--dark-border);
}

.header .top, .header .bottom {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.header a {
  color: var(--text-color);
  margin: 15px 0;
  font-size: 28px;
  text-decoration: none;
  transition: all 0.3s ease;
  padding: 12px;
  border-radius: 12px;
  position: relative;
  background-color: transparent;
}

.header a::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 0;
  height: 0;
  border-radius: 12px;
  background: var(--primary-color);
  opacity: 0;
  transition: all 0.3s ease;
  z-index: -1;
}

.header a:hover::after {
  width: 100%;
  height: 100%;
  opacity: 0.2;
}

.header a:hover {
  cursor: pointer;
  transform: translateX(5px);
  color: var(--primary-color);
}

.header a.mdi-home:hover {
  color: #4CAF50;
}

.header a.mdi-information:hover {
  color: #2196F3;
}

.header a.mdi-align-horizontal-left:hover {
  color: #FF9800;
}

.header a.mdi-file-download:hover {
  color: #FF5722;
}

.header a.mdi-linkedin:hover {
  color: #0077B5;
}

.header a.mdi-github:hover {
  color: #ffffff;
}

.header a.mdi-gmail:hover {
  background-image: linear-gradient(to left, #EA4335, #FBBC04, #34A853, #4285F4);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>